/* eslint-disable @typescript-eslint/no-explicit-any */
export default function DecodeJSON(getValues: any, key: string): any {
  const isArray = Array.isArray(getValues[key])
  if (isArray) {
    for (const index in getValues[key]) {
      for (const i in getValues[key][index]) {
        getValues[key][index][i] = DecodeJSON(getValues[key][index], i)
      }
    }
  } else {
    // Skip decoding for complex objects (like fill-blank data)
    if (typeof getValues[key] === 'object' && getValues[key] !== null) {
      // Don't decode complex objects, return as-is
      return getValues[key]
    }

    // Only decode strings. Escape lone "%" (e.g. "150%") so decodeURI can still
    // decode valid sequences like %C3%A1 in the same value.
    if (typeof getValues[key] === 'string') {
      getValues[key] = decodeURI(
        getValues[key].replace(/%(?![0-9A-Fa-f]{2})/g, '%25')
      )
    }
  }
  return getValues[key]
}
